const featureItems = [
  {
    id: 1,
    icon: 'ri-global-line',
    title: '全网覆盖',
    desc: '收录200+吃瓜黑料网站来源，涵盖51黑料网站、91黑料网站等主流平台及小众吃瓜社区，一站式满足所有吃瓜需求。',
  },
  {
    id: 2,
    icon: 'ri-timer-flash-line',
    title: '实时同步',
    desc: '7×24小时自动监控，热门话题榜单每5分钟刷新一次，确保你不漏掉任何一条最新黑料网站动态。',
  },
  {
    id: 3,
    icon: 'ri-filter-3-line',
    title: '智能筛选',
    desc: '基于热度、可靠性和讨论量的多维度排序算法，帮你快速从海量信息中定位最有价值的网红黑料网站内容。',
  },
  {
    id: 4,
    icon: 'ri-shield-user-line',
    title: '隐私优先',
    desc: '不追踪用户行为，不强制注册，浏览完全匿名。投稿渠道严格保密，保护每一位吃瓜群众的信息安全。',
  },
];

export default function FeaturesSection() {
  return (
    <section id="features" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-4xl font-bold font-heading text-foreground-950">
            特色优势
          </h2>
          <p className="mt-3 text-sm md:text-base text-foreground-500 max-w-xl mx-auto">
            选择黑料网站作为你的吃瓜入口，这些理由够不够
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {featureItems.map((item) => (
            <div
              key={item.id}
              className="bg-background-50 rounded-xl p-6 md:p-7 border border-background-200/70 hover:border-primary-200/50 transition-all duration-300 text-center group"
            >
              <div className="w-14 h-14 mx-auto mb-5 rounded-2xl bg-primary-100 flex items-center justify-center group-hover:bg-primary-200 transition-colors">
                <i className={`${item.icon} text-2xl text-primary-500`}></i>
              </div>
              <h3 className="text-lg font-bold font-heading text-foreground-900 mb-3">
                {item.title}
              </h3>
              <p className="text-sm text-foreground-500 leading-relaxed">
                {item.desc}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}